import { createApi } from "@reduxjs/toolkit/query/react";

import {
    ImageRenderFormat,
    ImageRenderer,
    type ImageArguments,
    type ReactionImageArguments,
} from "../../data/models/schemas";
import { IReaction } from "../reducers/reactions";
import { baseQuery } from "./baseQuery";

export type IReactionImageRequest = Omit<ReactionImageArguments, "reaction"> & {
    reaction: IReaction;
};

const normalizeImagePayload = (payload: unknown): string => {
    if (typeof payload === "string") {
        return payload;
    }

    if (payload == null) {
        return "";
    }

    return String(payload);
};

const serializeReactionCacheKey = (reaction: IReaction): string =>
    JSON.stringify(reaction, (key, value) =>
        key === "ui_id" ? undefined : value
    );

export const imageApi = createApi({
    reducerPath: "imageApi",
    baseQuery,
    endpoints: (builder) => ({
        getStructureImage: builder.query<string, ImageArguments>({
            query: (body) => ({
                path: "chemicals/image",
                method: "POST",
                body,
            }),
            transformResponse: normalizeImagePayload,
            keepUnusedDataFor: 300,
        }),
        getReactionImage: builder.query<string, IReactionImageRequest>({
            query: (body) => ({
                path: "reactions/image",
                method: "POST",
                body,
            }),
            transformResponse: normalizeImagePayload,
            serializeQueryArgs: ({ endpointName, queryArgs }) =>
                `${endpointName}|${queryArgs.renderer ?? ImageRenderer.INDIGO}|${queryArgs.format ?? ImageRenderFormat.PNG}|${queryArgs.width}|${queryArgs.height}|${serializeReactionCacheKey(queryArgs.reaction)}`,
            keepUnusedDataFor: 300,
        }),
    }),
});

export const { useGetStructureImageQuery, useGetReactionImageQuery } = imageApi;
